import React from 'react';
import { useCard } from '../../../../contexts/cardContext';
import { useColumns } from '../../../../contexts/columnsContext';
import { useUser } from '../../../../contexts/userContext';
import UpdateCard from '../../../forms/UpdateCard';
import Historic from '../../../forms/Historic';
import Tarefas from '../../../forms/Tarefas';
import Compartilhar from '../../../forms/Compartilhar';
import ModuloEsquadrias from '../../../forms/ModuloEsquadrias';
import Anexos from '../../../Anexos';
import CustomModule from '../../../DynamicForm/CustomModule';
import ModuloPedidos from '../../../ModuloPedido';
import EmailModal from '../../../forms/EmailModal';
import DocumentosRelatorios from '../../../DocumentosRelatorios';
import Loading from '../../../Loading';
import Messenger from '../../../Messenger';
import Calendario from '../../../Calendario';
import Faktory from '../../../Faktory';
import Avatar from '../../../Avatar';
import WhatsappZapiFloatingButton from '../../../WhatsappZapi/WhatsappZapiFloatingButton';
import ImportExcelSuiteFlow from '../../../ImportExcelSuiteFlow';

function NewHomeOverlays({ theme, showCalendar, onCloseCalendar }) {
  const {
    user,
    openCloseCustomModule,
    openCloseModalAvatar,
    openCloseImportExcelSuiteFlow,
  } = useUser();
  const { showFaktoryModule } = useColumns();
  const {
    currentCardData,
    openCloseUpdateCard,
    openCloseHistoricModal,
    setOpenCloseHistoricModal,
    openCloseTarefasModal,
    setOpenCloseTarefasModal,
    openCloseCompartilharModal,
    setOpenCloseCompartilharModal,
    openCloseModuloEsquadriasModal,
    openCloseAnexosModal,
    openClosePedidosModal,
    openCloseEmailModal,
    openCloseDocumentosRelatoriosModal,
    openCloseModalMessenger,
    setOpenCloseModalMessenger,
  } = useCard();

  return (
    <>
      {openCloseUpdateCard && currentCardData && <UpdateCard idCard={currentCardData.card_id} cardData={currentCardData} />}
      {openCloseHistoricModal && currentCardData && <Historic idCard={currentCardData.card_id} cardData={currentCardData} closeModal={() => setOpenCloseHistoricModal(false)} />}
      {openCloseTarefasModal && currentCardData && <Tarefas idCard={currentCardData.card_id} cardData={currentCardData} closeModal={() => setOpenCloseTarefasModal(false)} />}
      {openCloseCompartilharModal && currentCardData && <Compartilhar idCard={currentCardData.card_id} cardData={currentCardData} closeModal={() => setOpenCloseCompartilharModal(false)} />}
      {openCloseModuloEsquadriasModal && currentCardData && <ModuloEsquadrias idCard={currentCardData.card_id} />}
      {openCloseAnexosModal && currentCardData && <Anexos idCard={currentCardData.card_id} cardData={currentCardData} />}
      {openCloseCustomModule && currentCardData && <CustomModule idCard={currentCardData.card_id} />}
      {openClosePedidosModal && currentCardData && <ModuloPedidos idCard={currentCardData.card_id} />}
      {openCloseEmailModal && currentCardData && <EmailModal />}
      {openCloseDocumentosRelatoriosModal && currentCardData && <DocumentosRelatorios idCard={currentCardData.card_id} />}
      {openCloseModalMessenger && <Messenger closeModal={() => setOpenCloseModalMessenger(false)} />}
      {showCalendar && user && <Calendario userId={user.id} closeModal={onCloseCalendar} />}
      {showFaktoryModule && currentCardData && <Faktory cardData={currentCardData} />}
      {openCloseModalAvatar && <Avatar />}
      {openCloseImportExcelSuiteFlow && <ImportExcelSuiteFlow />}
      <Loading />
      <WhatsappZapiFloatingButton theme={theme} />
    </>
  );
}

export default NewHomeOverlays;
